document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.kv-timeline__body').forEach(initTimeline);
});

function initTimeline(body) {
  var fill = body.querySelector('.kv-timeline__line-fill');
  var milestones = body.querySelectorAll('.kv-timeline__milestone');
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (reduceMotion) {
    if (fill) fill.style.height = '100%';
    milestones.forEach(function (m) {
      m.classList.add('kv-timeline--visible');
    });
    return;
  }

  var ticking = false;
  function updateFill() {
    if (!fill) return;
    var rect = body.getBoundingClientRect();
    var viewportHeight = window.innerHeight;
    var start = viewportHeight * 0.85;
    var end = viewportHeight * 0.35;
    var progress = (start - rect.top) / (start - end + rect.height);
    progress = Math.max(0, Math.min(1, progress));
    fill.style.height = progress * 100 + '%';
    ticking = false;
  }

  window.addEventListener(
    'scroll',
    function () {
      if (!ticking) {
        requestAnimationFrame(updateFill);
        ticking = true;
      }
    },
    { passive: true }
  );
  updateFill();

  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('kv-timeline--visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.4 }
    );
    milestones.forEach(function (m) {
      observer.observe(m);
    });
  } else {
    milestones.forEach(function (m) {
      m.classList.add('kv-timeline--visible');
    });
  }
}
